import { create } from 'zustand';

import { CrmSegment } from './CrmSegment.enum';
import { SourceClassification } from './source-classification.enum';

type CrmStore = {
  filters: {
    subscription: string[];
    classification: string[];
    product: string[];
    leadsSource: string[];
    otpOffers: string[];
    additional: string[];
    freeOffers: string[];
    convertedTo: string[];
    conversionStatus: string[];
  };
  searchTerm: string;
  segment: CrmSegment | null;
  handleFilterChange: (filterName: string, value: any) => void;
  setSearchTerm: (searchTerm: string) => void;
  setActiveSegment: (segment: CrmSegment) => void;
  getClassification: () => string[];
};

const DEFAULT_FILTER_VALUE = {
  subscription: [],
  classification: [],
  product: [],
  leadsSource: [],
  otpOffers: [],
  additional: [],
  freeOffers: [],
  convertedTo: [],
  conversionStatus: [],
};

export const DEFAULT_FILTERS = {
  subscription: DEFAULT_FILTER_VALUE.subscription,
  classification: DEFAULT_FILTER_VALUE.classification,
  product: DEFAULT_FILTER_VALUE.product,
  leadsSource: DEFAULT_FILTER_VALUE.leadsSource,
  otpOffers: DEFAULT_FILTER_VALUE.otpOffers,
  additional: DEFAULT_FILTER_VALUE.additional,
  freeOffers: DEFAULT_FILTER_VALUE.freeOffers,
  convertedTo: DEFAULT_FILTER_VALUE.convertedTo,
  conversionStatus: DEFAULT_FILTER_VALUE.conversionStatus,
};

export const useCrmStore = create<CrmStore>((set, get) => ({
  filters: DEFAULT_FILTERS,
  searchTerm: '',
  segment: CrmSegment.Subscribed,
  handleFilterChange: (filterName, value) => {
    set((state) => ({
      filters: {
        ...state.filters,
        [filterName]:
          value ??
          DEFAULT_FILTER_VALUE[filterName as keyof typeof DEFAULT_FILTER_VALUE],
      },
    }));
  },
  setSearchTerm: (searchTerm) => set({ searchTerm }),
  setActiveSegment: (segment) => {
    if (get().segment === segment) {
      return;
    }

    set({ segment, filters: DEFAULT_FILTERS, searchTerm: '' });
  },
  getClassification: () => {
    const { classification } = get().filters;
    // we treat GiftedAnnualSubscription as Paid subscription
    return classification.includes(SourceClassification.PaidSubscription)
      ? [...classification, SourceClassification.GiftedAnnualSubscription]
      : classification;
  },
}));
